import React, { useEffect } from 'react';
import { Navigate, Outlet, useParams } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';
import { AccountProvider } from '../../context/AccountContext';
import LegacyRedirect from '../layouts/LegacyRedirect';
import { isAccountId } from '../../constants/permissions';

const RequireAccount = ({ children }) => {
  const { accountId } = useParams();
  const { accounts, canAccessAllAccounts, rememberLastAccount } = useAuth();

  if (!isAccountId(accountId)) {
    return <LegacyRedirect />;
  }

  const belongsToUser = (accounts || []).some(
    (account) => String(account.hubSpotId) === String(accountId)
  );

  if (!canAccessAllAccounts && !belongsToUser) {
    return <Navigate to="/accounts" replace />;
  }

  return (
    <RememberedAccount accountId={accountId} rememberLastAccount={rememberLastAccount}>
      <AccountProvider>
        {children || <Outlet />}
      </AccountProvider>
    </RememberedAccount>
  );
};

const RememberedAccount = ({ accountId, rememberLastAccount, children }) => {
  useEffect(() => {
    rememberLastAccount?.(accountId);
  }, [accountId, rememberLastAccount]);

  return children;
};

export default RequireAccount;
